export const SHEET_VALIDATION_STATUSES = Object.freeze({
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  VALID: 'valid',
  INVALID: 'invalid',
});

export const SHEET_STATUS_META = Object.freeze({
  [SHEET_VALIDATION_STATUSES.PENDING]: { label: 'Pendiente', variant: 'warning' },
  [SHEET_VALIDATION_STATUSES.IN_PROGRESS]: { label: 'En proceso', variant: 'info' },
  [SHEET_VALIDATION_STATUSES.VALID]: { label: 'Válida', variant: 'success' },
  [SHEET_VALIDATION_STATUSES.INVALID]: { label: 'Inválida', variant: 'danger' },
});

export const CALL_RESULTS = Object.freeze({
  CONFIRMED: 'confirmed',
  NOT_CONFIRMED: 'not_confirmed',
  CALL_BACK: 'call_back',
  NO_ANSWER: 'no_answer',
  WRONG_NUMBER: 'wrong_number',
  OUT_OF_SERVICE: 'out_of_service',
  NOT_APPLICABLE: 'not_applicable',
  NOT_INTERESTED: 'not_interested',
  PENDING: 'pending',
});

export const CALL_RESULT_LABELS = Object.freeze({
  [CALL_RESULTS.CONFIRMED]: 'Contestó y confirmó',
  [CALL_RESULTS.NOT_CONFIRMED]: 'Contestó y no confirmó',
  [CALL_RESULTS.CALL_BACK]: 'Contestó, volver a llamar',
  [CALL_RESULTS.NO_ANSWER]: 'No contestó',
  [CALL_RESULTS.WRONG_NUMBER]: 'Número incorrecto',
  [CALL_RESULTS.OUT_OF_SERVICE]: 'Fuera de servicio',
  [CALL_RESULTS.NOT_APPLICABLE]: 'No corresponde',
  [CALL_RESULTS.NOT_INTERESTED]: 'No desea participar',
  [CALL_RESULTS.PENDING]: 'Pendiente',
});

export const CONTACTED_CALL_RESULTS = Object.freeze([
  CALL_RESULTS.CONFIRMED,
  CALL_RESULTS.NOT_CONFIRMED,
  CALL_RESULTS.CALL_BACK,
  CALL_RESULTS.NOT_INTERESTED,
]);

export const REJECTED_CALL_RESULTS = Object.freeze([
  CALL_RESULTS.NOT_CONFIRMED,
  CALL_RESULTS.NOT_INTERESTED,
]);
